import type {Valid} from 'schemaDefinition/types';

export const aggregateValid = (...valids: (Valid | undefined)[]): Valid => {
  return valids.some(v => v === 'error')
    ? 'error'
    : valids.some(v => v === 'warning')
      ? 'warning'
      : 'valid';
};
